var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox relative" },
    [
      _vm.checkPermi(["platform:integral:order:invoice:list"])
        ? _c(
            "el-card",
            {
              staticClass: "ivu-mt",
              attrs: {
                bordered: false,
                shadow: "never",
                "body-style": { padding: 0 },
              },
            },
            [
              _c(
                "div",
                { staticClass: "padding-add" },
                [
                  _c(
                    "el-form",
                    {
                      attrs: { inline: "", "label-position": "right" },
                      nativeOn: {
                        submit: function ($event) {
                          $event.preventDefault()
                        },
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "时间选择：" } },
                        [
                          _c("el-date-picker", {
                            staticClass: "form_content_width",
                            attrs: {
                              "value-format": "yyyy-MM-dd",
                              format: "yyyy-MM-dd",
                              size: "small",
                              type: "daterange",
                              placement: "bottom-end",
                              placeholder: "自定义时间",
                            },
                            on: { change: _vm.onchangeTime },
                            model: {
                              value: _vm.timeVal,
                              callback: function ($$v) {
                                _vm.timeVal = $$v
                              },
                              expression: "timeVal",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "订单编号：", "label-width": "66px" },
                        },
                        [
                          _c("el-input", {
                            staticClass: "form_content_width",
                            attrs: {
                              placeholder: "请输入订单号",
                              size: "small",
                              clearable: "",
                            },
                            nativeOn: {
                              keyup: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.handleSearchList($event)
                              },
                            },
                            model: {
                              value: _vm.tableFrom.orderNo,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.tableFrom,
                                  "orderNo",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "tableFrom.orderNo",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "用户搜索：",
                            "label-for": "nickname",
                          },
                        },
                        [
                          _c("UserSearchInput", {
                            model: {
                              value: _vm.tableFrom,
                              callback: function ($$v) {
                                _vm.tableFrom = $$v
                              },
                              expression: "tableFrom",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary", size: "small" },
                              on: { click: _vm.handleSearchList },
                            },
                            [_vm._v("查询")]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: { size: "small" },
                              on: { click: _vm.handleReset },
                            },
                            [_vm._v("重置")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
      _vm.checkPermi([
        "platform:integral:order:status:num",
        "platform:integral:order:invoice:list",
      ])
        ? _c(
            "el-card",
            {
              staticClass: "box-card mt16",
              attrs: {
                shadow: "never",
                bordered: false,
                "body-style": { padding: "0 20px 20px" },
              },
            },
            [
              _c(
                "el-tabs",
                {
                  staticClass: "list-tabs",
                  on: { "tab-click": _vm.handleSearchList },
                  model: {
                    value: _vm.tableFrom.status,
                    callback: function ($$v) {
                      _vm.$set(_vm.tableFrom, "status", $$v)
                    },
                    expression: "tableFrom.status",
                  },
                },
                [
                  _c("el-tab-pane", {
                    attrs: {
                      name: "all",
                      label: "全部(" + (_vm.orderChartType.all || 0) + ")",
                    },
                  }),
                  _c("el-tab-pane", {
                    attrs: {
                      name: "unPaid",
                      label: "待支付(" + (_vm.orderChartType.unPaid || 0) + ")",
                    },
                  }),
                  _c("el-tab-pane", {
                    attrs: {
                      name: "notShipped",
                      label:
                        "待发货(" + (_vm.orderChartType.notShipped || 0) + ")",
                    },
                  }),
                  _c("el-tab-pane", {
                    attrs: {
                      name: "spike",
                      label: "待收货(" + (_vm.orderChartType.spike || 0) + ")",
                    },
                  }),
                  _c("el-tab-pane", {
                    attrs: {
                      name: "receiving",
                      label:
                        "已收货(" + (_vm.orderChartType.receiving || 0) + ")",
                    },
                  }),
                  _c("el-tab-pane", {
                    attrs: {
                      name: "complete",
                      label:
                        "交易完成(" + (_vm.orderChartType.complete || 0) + ")",
                    },
                  }),
                  _c("el-tab-pane", {
                    attrs: {
                      name: "cancel",
                      label: "已取消(" + (_vm.orderChartType.cancel || 0) + ")",
                    },
                  }),
                  _c("el-tab-pane", {
                    attrs: {
                      name: "deleted",
                      label:
                        "已删除(" + (_vm.orderChartType.deleted || 0) + ")",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.listLoading,
                      expression: "listLoading",
                    },
                  ],
                  staticClass: "mt20",
                  attrs: {
                    data: _vm.tableData.data,
                    size: "mini",
                    "highlight-current-row": "",
                    "row-key": function (row) {
                      return row.orderNo
                    },
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: { label: "订单号", "min-width": "220" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("div", { staticClass: "acea-row" }, [
                                _c("span", {
                                  class:
                                    parseInt(scope.row.refundStatus) > 0
                                      ? "colorPrompt"
                                      : "",
                                  staticStyle: { display: "block" },
                                  domProps: {
                                    textContent: _vm._s(scope.row.orderNo),
                                  },
                                }),
                              ]),
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: scope.row.isUserDel,
                                      expression: "scope.row.isUserDel",
                                    },
                                  ],
                                  staticClass: "colorPrompt",
                                  staticStyle: { display: "block" },
                                },
                                [_vm._v("用户已删除")]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      567560887
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "用户昵称", "min-width": "150" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "span",
                                {
                                  class:
                                    scope.row.isLogoff == true
                                      ? "colorPrompt"
                                      : "",
                                },
                                [
                                  _vm._v(
                                    _vm._s(scope.row.nickName) +
                                      " | " +
                                      _vm._s(scope.row.uid)
                                  ),
                                ]
                              ),
                              scope.row.isLogoff == true
                                ? _c(
                                    "span",
                                    {
                                      class:
                                        scope.row.isLogoff == true
                                          ? "colorPrompt"
                                          : "",
                                    },
                                    [_vm._v("|")]
                                  )
                                : _vm._e(),
                              scope.row.isLogoff == true
                                ? _c("span", { staticClass: "colorPrompt" }, [
                                    _vm._v("(已注销)"),
                                  ])
                                : _vm._e(),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3927248191
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "payPrice",
                      label: "实际金额",
                      "min-width": "80",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "redeemIntegral",
                      label: "使用积分",
                      "min-width": "80",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: { label: "订单状态", "min-width": "100" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "span",
                                {
                                  staticClass: "tag-background tag-padding",
                                  class:
                                    scope.row.status < 5
                                      ? "doingTag"
                                      : "endTag",
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("orderStatusFilter")(
                                        scope.row.status
                                      )
                                    )
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      4057805868
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "createTime",
                      label: "下单时间",
                      "min-width": "150",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: { width: "135", fixed: "right", label: "操作" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm.checkPermi(["platform:integral:order:detail"])
                                ? _c(
                                    "a",
                                    {
                                      on: {
                                        click: function ($event) {
                                          return _vm.onOrderDetails(
                                            scope.row.orderNo
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("详情 ")]
                                  )
                                : _vm._e(),
                              scope.row.status === 1 ||
                              (scope.row.status === 2 &&
                                _vm.checkPermi([
                                  "platform:integral:order:send",
                                ]))
                                ? [
                                    _c("el-divider", {
                                      attrs: { direction: "vertical" },
                                    }),
                                    _c(
                                      "a",
                                      {
                                        on: {
                                          click: function ($event) {
                                            return _vm.sendOrder(scope.row)
                                          },
                                        },
                                      },
                                      [_vm._v("发货 ")]
                                    ),
                                  ]
                                : _vm._e(),
                              scope.row.status > 0 &&
                              _vm.checkPermi(["platform:integral:order:mark"])
                                ? [
                                    _c("el-divider", {
                                      attrs: { direction: "vertical" },
                                    }),
                                    _c(
                                      "a",
                                      {
                                        on: {
                                          click: function ($event) {
                                            return _vm.onOrderMark(scope.row)
                                          },
                                        },
                                      },
                                      [_vm._v("备注 ")]
                                    ),
                                  ]
                                : _vm._e(),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      316394635
                    ),
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "block" },
                [
                  _c("el-pagination", {
                    attrs: {
                      background: "",
                      "page-sizes": _vm.$constants.page.limit,
                      "page-size": _vm.tableFrom.limit,
                      "current-page": _vm.tableFrom.page,
                      layout: "total, sizes, prev, pager, next, jumper",
                      total: _vm.tableData.total,
                    },
                    on: {
                      "size-change": _vm.handleSizeChange,
                      "current-change": _vm.pageChange,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c("details-from", {
        ref: "orderDetail",
        attrs: { orderNo: _vm.orderNo },
      }),
      _c("order-send", {
        ref: "send",
        attrs: { orderNo: _vm.orderNo },
        on: { submitFail: _vm.handleSearchList },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }